export const IS_DEMO =
  process.env.REACT_APP_DEMO_MODE === "true" ||
  process.env.REACT_APP_DEMO_MODE === "1";

export const DEMO_ACCOUNTS = [
  { role: "Admin", email: "admin@bansal.com", password: "admin123" },
  { role: "Manager", email: "manager@bansal.com", password: "password123" },
  { role: "Purchaser", email: "purchaser@bansal.com", password: "password123" },
  { role: "Guard", email: "guard@bansal.com", password: "password123" },
  { role: "Weighbridge", email: "weighbridge@bansal.com", password: "password123" },
  { role: "Lab", email: "lab@bansal.com", password: "password123" },
  { role: "Supervisor", email: "supervisor@bansal.com", password: "password123" },
  { role: "Unloading Supervisor", email: "unloading@bansal.com", password: "password123" },
  { role: "Accounts", email: "accounts@bansal.com", password: "password123" },
  { role: "Accounts Manager", email: "accounts.manager@bansal.com", password: "password123" },
];
